"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../helpers/time");
var Coupon_1 = require("../../classes/Coupon");
var PaymentRequest_1 = require("../payments/PaymentRequest");
/**
 * @description This service handles billing configuration and order details
 *
 * @param UserService - Service to handle user
 * @param $rootScope - Root scope
 * @param CrmTasksModel - Service to handle CRM tasks
 * @param OrdersModel - Service to handle orders
 */
var OrderDetailsService = /** @class */ (function () {
    function OrderDetailsService(UserService, $rootScope, CrmTasksModel, OrdersModel) {
        this.payment = {
            id: 0,
            charged_on: "",
            school_id: 0,
            user_id: 0,
            fee_id: 0,
            order_id: 0,
            amount: 0,
            charge_id: "",
            payment_method: "",
            notes: "",
            created_at: "",
            updated_at: "",
            deleted_at: "",
            void: false,
            check_number: "",
        };
        this.order = {
            id: 0,
            paid: false,
            total: 0,
            student_id: 0,
            school_id: 0,
            organization_id: 0,
            status: "",
            source: "",
            notes: [],
            created_at: "",
            updated_at: "",
            deleted_at: "",
            created_by: 0,
            coupons: [],
            lineitems: [],
        };
        this.currentUser = UserService.getCurrentUser();
        this.$rootScope = $rootScope;
        this.CrmTasksModel = CrmTasksModel;
        this.OrdersModel = OrdersModel;
        this.details = {};
        this.billingConfig = {
            gateway: "",
            gateway_config: {
                paypal_rest_api_client_id: "",
            },
            policyMeta: {
                id: "",
            },
        };
        this.transformPayment = this.transformPayment.bind(this);
    }
    /**
     * Posts the payment set with setPayment under the host's key. This service
     * is a singleton, so the key belongs to the host screen that sees the
     * answer and settles it.
     */
    OrderDetailsService.prototype.submitPayment = function (orderPayment) {
        var body = {
            order_id: this.payment.order_id,
            payment: this.transformPayment(this.payment),
        };
        return this.OrdersModel.submitPayment(orderPayment.bodyFor(__assign(__assign({}, body), { payment: (0, PaymentRequest_1.withoutOneTimeToken)(body.payment) }), function (requestId) { return (__assign(__assign({}, body), { request_id: requestId })); }));
    };
    OrderDetailsService.prototype.transformPayment = function (payment) {
        if (payment.payment_method === "cash") {
            var newPayment = Object.assign({}, payment);
            delete newPayment.card;
            return newPayment;
        }
        if (payment.payment_method === "check") {
            var newPayment = Object.assign({}, payment);
            delete newPayment.card;
            return newPayment;
        }
        if (payment.payment_method === "other") {
            var newPayment = Object.assign({}, payment);
            delete newPayment.card;
            return newPayment;
        }
        return payment;
    };
    /**
     * @description Configure billing configuration
     * @param response - Response from API
     * @returns Billing configuration
     */
    OrderDetailsService.prototype.configureBilling = function (response) {
        var billingConfig = {
            policyMeta: {},
            gateway: "",
            gateway_config: {},
        };
        response.policy.policymeta.forEach(function (meta) {
            billingConfig.policyMeta[meta.meta_key] = meta.meta_value;
        });
        billingConfig.policyMeta.id = response.policy.id;
        billingConfig.gateway = billingConfig.policyMeta.billing_gateway;
        billingConfig.gateway_config = {
            authorize_api_client_key: billingConfig.policyMeta.authorize_api_client_key,
            authorize_api_login_id: billingConfig.policyMeta.authorize_api_login_id,
            stripe_publishable_key: billingConfig.policyMeta.stripe_publishable_key,
            stripe_secret_key: billingConfig.policyMeta.stripe_secret_key,
            square_application_id: billingConfig.policyMeta.square_application_id,
            square_access_token: billingConfig.policyMeta.square_access_token,
            square_environment: billingConfig.policyMeta.square_environment,
            paypal_rest_api_client_id: billingConfig.policyMeta.paypal_rest_api_client_id,
        };
        this.setBillingConfig(billingConfig);
        return billingConfig;
    };
    OrderDetailsService.prototype.setupOrderDetails = function (response, payment) {
        var order = response.data.order;
        order.student = payment.student;
        order.payments = response.data.payments;
        var coupons = [].concat(order.coupons).map(function (coupon) {
            return new Coupon_1.Coupon(coupon);
        });
        order.created_at = (0, time_1.formatDateTime)(order.created_at, "MM/DD/YYYY h:mm A");
        order.coupons = coupons;
        this.setOrder(order);
        return order;
    };
    OrderDetailsService.prototype.setOrder = function (data) {
        this.order = data;
    };
    OrderDetailsService.prototype.clearOrder = function () {
        this.order = {
            id: 0,
            paid: false,
            total: 0,
            student_id: 0,
            school_id: 0,
            organization_id: 0,
            status: "",
            source: "",
            created_at: "",
            updated_at: "",
            deleted_at: "",
            created_by: 0,
            coupons: [],
            lineitems: [],
            notes: [],
        };
    };
    OrderDetailsService.prototype.getOrder = function () {
        return this.order;
    };
    OrderDetailsService.prototype.setPayment = function (data) {
        this.payment = data;
    };
    OrderDetailsService.prototype.clearPayment = function () {
        this.payment = {
            id: 0,
            charged_on: "",
            school_id: 0,
            user_id: 0,
            fee_id: 0,
            order_id: 0,
            amount: 0,
            charge_id: "",
            payment_method: "",
            notes: "",
            created_at: "",
            updated_at: "",
            deleted_at: "",
            void: false,
            check_number: "",
        };
    };
    OrderDetailsService.prototype.getPayment = function () {
        return this.payment;
    };
    OrderDetailsService.prototype.setPayPalDetails = function (details) {
        this.details = details;
    };
    OrderDetailsService.prototype.getPayPalDetails = function () {
        return this.details;
    };
    OrderDetailsService.prototype.handlePayPalPayment = function (details) {
        // console.log('PaPal Payment Details: ', details)
        // this.setPayPalDetails(details) //save details
        // this.submitPayment(payment);
    };
    OrderDetailsService.prototype.setBillingConfig = function (config) {
        this.billingConfig = config;
    };
    return OrderDetailsService;
}());
OrderDetailsService.$inject = [
    "UserService",
    "$rootScope",
    "CrmTasksModel",
    "OrdersModel",
];
exports.default = OrderDetailsService;
